// Formats the `cost` object the backend returns for each AI run (see ClaudeMenuClient#usage_summary).
export function formatAiCost(cost) {
  const usd = cost.cost_usd < 0.1 ? cost.cost_usd.toFixed(4) : cost.cost_usd.toFixed(2)
  const tokens = cost.input_tokens + cost.output_tokens + cost.cache_creation_input_tokens + cost.cache_read_input_tokens
  return `$${usd} (${cost.requests} ${cost.requests === 1 ? 'request' : 'requests'} · ${tokens.toLocaleString()} tokens)`
}
